angular.module('env.custom.customModule', [
    'env.custom.customModule.signup',
    'env.custom.customModule.filters',
    'env.custom.customModule.statistics',
    'env.custom.customModule.assetsRegister',
    'env.custom.customModule.attachmentsHelperService',
    'env.custom.customModule.gridItemsActionsHelperService',
    'env.custom.customModule.approvalFields',
    'env.custom.customModule.orderItemSummary',
    'env.custom.customModule.orderFiles'
])
    .run(function ($rootScope, $log, toastr, $q, gridItemsActionsHelperService) {
        // Custom click handler for the custom button of the 'customer' branded grid
        // to order second pair with particular options
        $rootScope.orderSecondPairHandler = function (dataItem) {
            var kg = $("#orderItemsGrid").data("kendoGrid");
            var row = kg.table.find('tr[data-uid="' + dataItem.uid + '"]');
            var ddOrderOption = row.find('select.ddOrderNow')[0];
            var orderOption = ddOrderOption ? ddOrderOption.value : '';
            //Now try to notify external application rendering the view
            try {
                //If we have the page loaded from inside the ScanApp then try to communicate it!
                doScriptNotify(dataItem.$model.order.$model.id + ":" + orderOption);
                $log.trace("Sent Order Id to ScanApp: " + dataItem.$model.order.$model.id + ":" + orderOption);
            } catch (e) {
                //Something went wrong and we probably just have the page loaded in the regular browser
                alert('Please run the Ortesi3D application and order second pair from the list of completed orders!');
                $log.error('Error during notifying of the external application about requested action.', e);
            }
        };

        $rootScope.orderNowDropDownOptions = {
            dataSource: [
                {text: 'Identical', value: 'SecondIdentical'},
                {text: 'Non-Identical', value: 'SecondNonIdentical'},
                {text: 'Cover Change', value: 'SecondIdenticalShellWithDifferentCover'}
            ],
            dataTextField: "text",
            dataValueField: "value",
            template: "<span class='k-state-default'><span>{{dataItem.text|translate}}</span></span>",
            select: function (e) {
                //console.log(document.getElementById('ddOrderNow').selectedOptions[0].value);
            },
            dataBound: function () {
                this.list.width('auto');
            }
        };

        //When this code runs on a page executed in browser container in iPad, the variable IamIPad will be defined
        $rootScope.isIPad = typeof (IamIPad) !== 'undefined' || (navigator.userAgent.indexOf('iPad;') !== -1 && navigator.userAgent.indexOf('AppleWebKit') !== -1);

        $rootScope.shipOrdersInGroup = function(group, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings) {
            gridItemsActionsHelperService.shipOrdersInGroup(group, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings);
        }

        $rootScope.setFreightReferenceToOrdersGroupAndProgress = function(group, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings) {
            gridItemsActionsHelperService.setFreightReferenceToOrdersGroupAndProgress(group, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings);
        }
    })

    .provider('$customActions', function CustomActions($injector, attachmentsHelperServiceProvider) {

        function handOutLeftFootScanFile(item) {
            var elem = document.createElement('a');
            elem.href = 'views/documents/download?id=' + attachmentsHelperServiceProvider.getLeftFootScanFileNameId(item);
            elem.target = 'hiddenIframe';
            elem.click();
        }

        this.handOutLeftFootScanFile = handOutLeftFootScanFile;
        this.$get = function ($log, $http) {

            this.handOutLeftFootScanFile = handOutLeftFootScanFile;

            return this;
        };
    })

;
